var SparkDigital = SparkDigital || {};

SparkDigital = (function () {

    /***********************************************************
    // GLOBAL - FOR STORING REUSABLE VARIABLES (EG. DOM)
    ***********************************************************/
    var global = {

        ajax_endpoints: window["ajax_endpoints"],

        google_recaptcha: window["google_recaptcha_site_key"],

        wp_nonce: window["wp_nonce"],

        breakpoint: {}, // bootstrap viewport

        assets_dir: window["assets_dir"],

        debug_mode: $('body').hasClass('debug-mode'), // Debug on-off state

        // Define ones that are being called everywhere
        elements: {
            body: $("body"),
            iframes: $("body.single iframe"), // Be specific where the iframes might be added
            inlineSmoothScroll: $("a[smooth-scroll], a[href^='#'], a[href^='/#']"), // Select all inline anchors
            inlinePopUps: $('[inline-modal]'), // For all inline popups
            iframePopUps: $('[inline-youtube], [inline-video], [inline-gmaps]'), // For all iframe popups
            lazyload: $('[data-bg], img[data-src], iframe[data-src], video[data-src], .lazy'), // Lazy load bg images, img/iframe/video HTML elements. 
        },

        site_lang: $('html').attr('lang'), // get site language

        storage_names: {
            user_contact: "user-contact"
        },


    },
        /***********************************************************
        // COMPONENTS THAT ARE USED ON MORE THAN ONE PAGE & CALLABLE
        ***********************************************************/
        components = {

            modal: {
                inline: function (elements) {
                    var elements = $(elements).length != 0 ? $(elements) : global.elements.inlinePopUps;

                    // if ($(elements).length > 0) {
                    //     $(elements).magnificPopup({
                    //         type: 'inline',
                    //         closeOnContentClick: true,
                    //         fixedContentPos: true,
                    //         mainClass: 'mfp-fade',
                    //         removalDelay: 160,
                    //     });
                    // }

                },
                iframe: function (elements) {
                    var elements = $(elements).length != 0 ? $(elements) : global.elements.iframePopUps;

                    if ($(elements).length > 0) {
                        // $(elements).magnificPopup({
                        //     //disableOn: 700,
                        //     type: 'iframe',
                        //     mainClass: 'mfp-fade',
                        //     removalDelay: 160,
                        //     preloader: false,
                        //     fixedContentPos: false
                        // });
                    }
                },
                gallery: function (elements) {
                    var elements = $(elements).length != 0 ? $(elements) : global.elements.galleries;
                    //console.log($(elements).length);
                    if ($(elements).length > 0) {

                        $(elements).magnificPopup({
                            type: 'image',
                            callbacks: {
                                open: function () {
                                    $('.headerFix').css('padding-right', 15);
                                }, //Fix for header moving when popup triggered
                                close: function () {
                                    $('.headerFix').css('padding-right', 0);
                                }
                            },
                            image: {
                                verticalFit: true,
                                titleSrc: function (item) {
                                    return item.el.parents('.gallery-item').find('.gallery-caption').text();
                                }

                            },
                            gallery: {
                                enabled: true,
                            },
                            mainClass: 'mfp-fade',
                            removalDelay: 160,
                            fixedContentPos: true,
                        });

                        // Separate remote trigger button to fire the magnificPopup gallery
                        var galleryHeaderImage = $(".postTopImage");
                        if ($(galleryHeaderImage).length > 0) {
                            $(galleryHeaderImage).click(function () {
                                $(elements).eq(0).trigger('click');
                                return false;
                            });
                        }
                    }

                },
            },
            privacy_consent: function () {
                // Generator: https://cookieconsent.insites.com
                // Doc: https://www.osano.com/cookieconsent/documentation/about-cookie-consent/
                jQuery(function () {

                    // Ensure CookieConsent JS Plugin exists
                    if (typeof window.cookieconsent !== "undefined") {

                        // Multisite    
                        switch (global.site_lang) {
                            // case "fr-FR": // French
                            //    var privacy_content = {
                            //         "message": "Ce site Internet utilise des cookies pour améliorer et personnaliser votre expérience. Pour plus d’informations sur la collecte et l’utilisation de vos informations, y compris l’utilisation de cookies, merci de consulter notre ",
                            //         "link": "politique de confidentialité",
                            //         "dismiss": "Ok",
                            //         "href": "/fr-fr/politique-de-confidentialite",
                            //         "target": "_blank",
                            //    };
                            // 	break;

                            default: // Defaults to English
                                var privacy_content = {
                                    "message": "This website uses cookies to ensure you get the best experience on our website. Please check out our ",
                                    "link": "privacy policy",
                                    "dismiss": "ACCEPT COOKIES",
                                    "href": "/privacy",
                                    "target": "_blank",
                                };
                        };

                        window.cookieconsent.initialise({
                            //dismissOnTimeout: 10,
                            position: "bottom-right",
                            palette: {
                                "popup": {
                                    //"text": "#fff",
                                    "background": "rgba(102, 201, 186, 1)"
                                }
                            },
                            elements: {
                                //header: '<span class="cc-header">{{header}}</span>&nbsp;',
                                //"message": "<div id='cookieconsent:desc'><p class='small cc-message' style='color:#fff'>{{message}}.</p></div>",
                                "messagelink": "<div id='cookieconsent:desc'><p class='small cc-message' style='color:#fff'>{{message}} <a aria-label='learn more about cookies' tabindex='0' class='cc-link' href='{{href}}' target='_blank'>{{link}}</a>.</p></div>",
                                "dismiss": "<a aria-label='dismiss cookie message' tabindex='0' class='buttonDefault cc-btn cc-dismiss small'>{{dismiss}}</a>"
                            },
                            content: privacy_content,
                        });

                    }

                });
            },
            smoothScroll: function (elements) {

                var elements = $(elements).length != 0 ? $(elements) : global.elements.inlineSmoothScroll;

                if ($(elements).length > 0) {
                    elements.click(function () {

                        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname && this.hash.slice(1) != "#" && this.hash.slice(1) != "") {
                            var target = $(this.hash);
                            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                            if (target.length) {

                                // If have parent section have 'hidden' class, remove before sliding in
                                if ($(target).closest('section.hidden')) {
                                    $(target).closest('section.hidden').removeClass('hidden');
                                }

                                var headerHeight = $("header.sticky-top").length > 0 ? parseInt($("header.sticky-top").css("height")) : 0;

                                // Target y position within the browser (24px is faux offset).
                                var scroll_top = target.offset().top - 24;

                                // Sticky menu
                                if (global.breakpoint.index > 1) {
                                    scroll_top = scroll_top - (headerHeight * 2.4);
                                } else {
                                    scroll_top = scroll_top - headerHeight;
                                }

                                // Wordpress Adminbar (Only on desktop, ignored on mobile)
                                if ($("#wpadminbar").length > 0) {
                                    scroll_top = scroll_top - ($("#wpadminbar").css("postiion") == "fixed" ? parseInt($("#wpadminbar").css("height")) : 0);
                                }

                                $('html, body').animate({
                                    scrollTop: scroll_top
                                }, 1500);
                                return false;
                            }
                        }

                    });
                }
            },
            stickyHeader: function () {
                // Uses Polyfill for browsers that does not support IntersectionObserver API

                //  Navigation target
                var sticky_nav = document.querySelector(".sticky-top");

                // Sticky Target
                var sticky_target = document.querySelector("#sticky-header-target");

                if ($(sticky_nav).length > 0 && $(sticky_target).length > 0) {

                    var observer = new IntersectionObserver(function (entries) {
                        // no intersection with screen
                        if (entries[0].intersectionRatio === 0) {
                            $(sticky_nav).addClass('scrolled');
                            if (global.debug_mode) {
                                console.log("Sticky Target: Outside");
                            }
                        }
                        // fully intersects with screen
                        else if (entries[0].intersectionRatio === 1) {
                            $(sticky_nav).removeClass('scrolled');
                            if (global.debug_mode) {
                                console.log("Sticky Target: Inside");
                            }
                        }

                    }, { threshold: [0, 1] });

                    observer.observe(sticky_target);
                }

            },

            stickComponentHeader: function () {

                $('table thead.sticky-top').each(function () {

                    let headerNavHeight = $('header.sticky-top').height();

                    let subMainNavHeight = $('nav.main-nav').height();

                    if (headerNavHeight != null && subMainNavHeight != null) {
                        if (global.breakpoint.index < 2) {
                            $(this).css('top', headerNavHeight);
                        } else {
                            $(this).css('top', headerNavHeight + subMainNavHeight);
                        }

                    }




                });

            },

            navBarToggle: function () {

                $(".nav-mobile-btn button").on("click", function () {
                    $(this).toggleClass('opened');
                    $(".nav-elements").toggleClass('swiped');
                });

            },

            // Compiles HandleBars
            handlebars: {

                // Use for tracking initialisation state
                init: false,

                // Use for storing cached template that has been compiled
                cached_template: {},

                // Render Template
                render: function (templateElement) {

                    // console.log("handlebars.render");

                    // Initialise helper if haven't 
                    if (this.init === false) this.extend();

                    if (templateElement === "" || templateElement === null) {
                        return false;
                    }

                    // Get ID and used for cached
                    var templateName = $(templateElement).attr("ID");

                    // console.log("Template Name: "+templateName);
                    // console.log(this.cached_template[templateName]);

                    if (this.cached_template[templateName] != undefined) {

                        // console.log("CACHED TEMPLATE");
                        return this.cached_template[templateName];

                    } else {

                        var templateSource = $(templateElement).html();

                        if (templateSource !== "" || templateSource !== null) {

                            // Compile handlebars and return
                            this.cached_template[templateName] = Handlebars.compile(templateSource);
                            return this.cached_template[templateName];
                        }
                    }

                    return false;
                },

                // Extend such as additional kelpers
                extend: function () {

                    // debug helper
                    // usage: {{debug}} or {{debug someValue}}
                    // from: @commondream (http://thinkvitamin.com/code/handlebars-js-part-3-tips-and-tricks/)
                    Handlebars.registerHelper("debug", function (optionalValue) {
                        console.log("Current Context");
                        console.log("====================");
                        console.log(this);

                        if (optionalValue) {
                            console.log("Value");
                            console.log("====================");
                            console.log(optionalValue);
                        }
                    });

                    Handlebars.registerHelper('reverse', function (arr) {

                        //console.log(typeof(arr))
                        if (global.polyfill_isArray(arr)) {
                            arr.reverse();
                        } else {
                            arr;
                        }

                    });

                    Handlebars.registerHelper('str_concatnate', function (a, b, opts) {
                        var str_combined = a + '' + b;
                        return new Handlebars.SafeString(str_combined);
                    });

                    Handlebars.registerHelper('str_replace', function (a, b, c, opts) {
                        var str_replaced = a.replace(b, c);
                        return new Handlebars.SafeString(str_replaced);
                    });

                    // Provides conditional string checks
                    Handlebars.registerHelper('if_eq', function (a, b, opts) {
                        if (a === b) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if string contains
                    Handlebars.registerHelper('if_contains', function (a, b, opts) {
                        if (a.indexOf(b) >= 0) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if obj contains
                    Handlebars.registerHelper('if_obj_contains', function (a, b, c, opts) {

                        var obj_founds = global.search_object_by_key(a, b, c);

                        if (obj_founds.length > 0) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if it's an object
                    Handlebars.registerHelper('is_obj', function (item, options) {
                        if (typeof item === "object") {
                            return options.fn(this);
                        } else {
                            return options.inverse(this);
                        }
                    });

                    // Comparsion Check
                    Handlebars.registerHelper('if_compare', function (lvalue, operator, rvalue, opts) {

                        var operators, result;

                        if (arguments.length < 3) {
                            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
                        }

                        if (opts === undefined) {
                            opts = rvalue;
                            rvalue = operator;
                            operator = "===";
                        }

                        operators = {
                            '==': function (l, r) {
                                return l == r;
                            },
                            '===': function (l, r) {
                                return l === r;
                            },
                            '!=': function (l, r) {
                                return l != r;
                            },
                            '!==': function (l, r) {
                                return l !== r;
                            },
                            '<': function (l, r) {
                                return l < r;
                            },
                            '>': function (l, r) {
                                return l > r;
                            },
                            '<=': function (l, r) {
                                return l <= r;
                            },
                            '>=': function (l, r) {
                                return l >= r;
                            },
                            'typeof': function (l, r) {
                                return typeof l == r;
                            }
                        };

                        if (!operators[operator]) {
                            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
                        }

                        result = operators[operator](lvalue, rvalue);

                        if (result) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }

                    });

                    //  Format a date
                    //  @link https://github.com/phstc/jquery-dateFormat
                    Handlebars.registerHelper('DateFormat', function (input, dateformat) {

                        // Normalize date to unix time
                        var unixTimestamp = new Date().getTime(input);
                        unixTimestamp = new Date(unixTimestamp).toISOString();

                        dateformat = dateformat == '' ? 'dd/MM/yyyy' : dateformat;

                        if (dateformat == 'pretty') {
                            return new Handlebars.SafeString($.format.prettyDate(new Date(unixTimestamp)));
                        } else {
                            return new Handlebars.SafeString($.format.date(new Date(unixTimestamp), dateformat));
                        }

                    });

                    // Finished initialisation
                    this.init = true;

                }


            },

            lazyLoad: function () {

                if (typeof (LazyLoad) != 'undefined') {

                    // @link https://github.com/verlok/lazyload
                    // Instantiate LazyLoad and make available for in Global JS scope
                    window.lazyLoadInstance = new LazyLoad({
                        //use_native: false, // Use browser native implementation if available
                        load_delay: 300, // Set delay loading when there's inline anchor so that it scrolls to the right spot
                    }, global.elements.lazyload);


                    /* 
                    BROWSER'S NATIVE PRINT EVENTS LISTENERS
                    --------------------------------------- 
                    In order to make browsers load all the images before printing
                    even if the user doesn't press the custom print button. 
                    NOTE that this works only partially in some browsers! */
                    var isSafari = /^((?!chrome|android).)*safari/i.test(
                        navigator.userAgent
                    );
                    if (!isSafari) {
                        window.onbeforeprint = function () {
                            window.lazyLoadInstance.loadAll();
                        };
                    } else {
                        // Safari doesn't support the onbeforeprint event
                        var mediaQueryList = window.matchMedia("print");
                        mediaQueryList.addListener(function (mql) {
                            if (mql.matches) {
                                window.lazyLoadInstance.loadAll();
                            }
                        });
                    }

                }

            },

            tabs: {
            },

            wow: function () {

                if (typeof (WOW) != 'undefined') {
                    //Wow js
                    wow = new WOW({
                        mobile: true,
                    })
                    wow.init();
                }

            },

            // Bootstrap Carousel
            // Only allow carousel to initialise and rotate within viewport
            bs_carousel: function () {


                // Uses Polyfill for browsers that does not support IntersectionObserver API

                var carouselTarget = document.querySelector(".carousel[data-ride='false']");


                if ($(carouselTarget).length > 0) {


                    var observer = new IntersectionObserver(function (entries) {

                        // fully intersects with screen
                        if (entries[0].intersectionRatio === 1) {


                            if ($(carouselTarget).attr("data-ride") == "false" || $(carouselTarget).attr("data-ride") == "1") {
                                // Set to true 
                                $(carouselTarget).attr("data-ride", "carousel");

                                // Autuplays carousel
                                $(carouselTarget).carousel({
                                    ride: 'carousel',
                                    // interval: 2800,
                                })
                            } else {
                                // re-activate carousel
                                $(carouselTarget).carousel('cycle');
                            }

                            if (global.debug_mode) {
                                console.log("Coursel Target: Inside viewport");
                            }
                        } else {

                            if ($(carouselTarget).attr("data-ride") == "carousel" || $(carouselTarget).attr("data-ride") == "0") {

                                // activate carousel
                                $(carouselTarget).carousel('pause');

                                if (global.debug_mode) {
                                    console.log("Coursel Target: Outside viewport");
                                }

                            }
                        }

                    }, { threshold: [0, 1] });

                    observer.observe(carouselTarget);

                }



            },

            forms: {

                // Default Bootstrap form validation
                init: function (forms) {

                    const _self = this;

                    // Fetch all the forms we want to apply custom Bootstrap validation styles to
                    forms = !!!forms && forms != undefined ? forms : $('form.needs-validation');

                    $(forms).each(function () {

                        const _form = this;

                        // $("input[name='postcode'], input[name='participant_dob'], textarea[name='message']").blur(function(){
                        //     tmpval = $(this).val();
                        //     if(tmpval == '') {
                        //         $(this).addClass('empty');
                        //         $(this).removeClass('has-value');
                        //     } else {
                        //         $(this).addClass('has-value');
                        //         $(this).removeClass('empty');
                        //     }
                        // });

                        /**
                         * @link https://bootstrap-datepicker.readthedocs.io/en/latest/index.html
                         */
                        // $("input[name='participant_dob']").datepicker({
                        //     container: '.datepicker-parent',
                        //     disableTouchKeyboard: false,
                        //     format:'dd/mm/yyyy'
                        // });


                        // MaxLength 
                        // @link https://github.com/mimo84/bootstrap-maxlength/
                        $(this).find('textarea[maxlength]').maxlength({
                            appendToParent: true
                        });

                        $(this).find('textarea').on('autosize:resized', function () {
                            $(this).trigger('maxlength.reposition');
                        });

                        $(this).on("submit", function (event) {

                            if ($(this).get(0).checkValidity() === false) {
                                event.preventDefault();
                                event.stopPropagation();

                                // Scroll to first error
                                var errorElements = $(this).find(".form-control:invalid");
                                // var errorElements =  $(this).find(".invalid-feedback:visible");
                                if ($(errorElements).length > 0) {
                                    $(errorElements)[0].scrollIntoView({ block: "center", behavior: 'smooth' });
                                }


                                // alert("isDefaultPrevented");
                            }

                            $(this).addClass('was-validated');


                        });


                    });

                    // DEBUG: Create and activate modal for use for confirmation or error
                    // components.bs_modal.show('Form successfully submitted!', '<p>CONTENT</p>');
                    // components.bs_modal.success('Form successfully submitted!','<p>CONTENT</p>');
                    // components.bs_modal.failed('Form successfully submitted!','<p>CONTENT</p>');


                    // Contact form
                    _self.contact.init();

                    // Get A Quote form
                    _self.get_a_quote.init();

                    // Mailchimp form
                    _self.mailchimp_subscription.init();

                    // DoneSafe Job Application form
                    _self.job_application.init();

                    // DoneSafe Job Expression Of Interest form
                    _self.job_eoi.init();

                    // DoneSafe Client Enquiry/Lead form
                    _self.client_enquiry.init();

                },

                // Enable/Disable form branching elements
                formBranching: {

                    form: null,

                    init: function (_form) {

                        const _self = this;

                        _self.form = _form;

                        var elements = $(_self.form).find('input[data-bs-toggle="collapse"][data-bs-target*="form-fields-branching-"],textarea[data-bs-toggle="collapse"][data-bs-target*="form-fields-branching-"],select[data-bs-toggle="collapse"][data-bs-target*="form-fields-branching-"],option[data-bs-toggle="collapse"][data-bs-target*="form-fields-branching-"]');

                        if ($(elements).length == 0) {
                            return;
                        }

                        $(elements).each(function () {

                            if ($(this).prop('nodeName') != undefined) {

                                if ($(this).prop('nodeName').toLowerCase() == 'input') {

                                    $(this).on('change', function () {

                                        if ($.trim($(this).val()) != '') {
                                            // alert($(this).val());
                                        } else {

                                        }

                                    });

                                }

                                if ($(this).prop('nodeName').toLowerCase() == 'textarea') {

                                    $(this).on('change', function () {

                                        if ($.trim($(this).val()) != '') {
                                            // alert($(this).val());
                                        } else {

                                        }

                                    });

                                }


                            }

                            if ($(this).prev().prop('nodeName') != undefined && $(this).prev().prop('nodeName').toLowerCase() == 'option') {

                                if ($(this).parent().attr('form-branching-initialised') == undefined) {

                                    $(this).parent().attr('form-branching-initialised', true);

                                    $(this).parent().on('change', function () {

                                        // Show
                                        _self.enableFieldGroups($(this).children("option:selected").attr('data-bs-target'));

                                        // alert($(this).children("option:selected").attr('data-bs-target'));

                                        $(_form).removeClass('was-validated');
                                        $(_form).removeClass('form-spam-validated');

                                    });

                                }

                            }

                        });

                    },

                    // Show group and fields
                    enableFieldGroups: function (_target) {

                        const _self = this;
                        _target = $(_self.form).find(_target);

                        _self.disableFieldGroups(_target);

                        if ($(_target).length > 0) {
                            $(_target).removeAttr('hidden');
                            $(_target).prop('hidden', false);
                            _self.enableFields(_target);
                        }

                    },

                    // Hide group and fields
                    disableFieldGroups: function (_target) {
                        const _self = this;
                        _target = $(_self.form).find("[id^='form-fields-branching-']");

                        if ($(_target).length > 0) {
                            $(_target).attr('hidden');
                            $(_target).prop('hidden', true);
                            _self.disableFields(_target);
                        }

                    },

                    // Enable various form fields
                    enableFields: function (_target) {

                        const _self = this;

                        var elements = $(_target).find('input,textarea,select,option');

                        if ($(elements).length == 0) {
                            return;
                        }

                        $(elements).each(function () {

                            if ($(this).prev().prop('nodeName') != undefined && $(this).prev().prop('nodeName').toLowerCase() == 'option') {
                                $(this).parent().prop('disabled', false);
                                $(this).parent()[0].options.selectedIndex = 0;
                            } else {
                                $(this).prop('disabled', false);
                            }

                        });

                    },

                    // Disable various form fields
                    disableFields: function (_target) {

                        const _self = this;

                        var elements = $(_target).find('input,textarea,select,option');

                        if ($(elements).length == 0) {
                            return;
                        }

                        $(elements).each(function () {

                            if ($(this).prev().prop('nodeName') != undefined && $(this).prev().prop('nodeName').toLowerCase() == 'option') {

                                $(this).parent().prop('disabled', true);

                                $(this).parent()[0].options.selectedIndex = 0;

                            } else {
                                $(this).prop('disabled', true);
                            }

                        });

                    },

                },

                // Function to end form if selected
                formEnd: {

                    form: null,

                    init: function (_form) {

                        const _self = this;

                        _self.form = _form;

                        var elements = $(_self.form).find('input[form-end!=""],option[form-end!=""],textarea[form-end!=""]');

                        if ($(elements).length == 0) {
                            return;
                        }

                        $(elements).each(function (i, el) {

                            if ($(this).prop('nodeName') != undefined) {

                                // if ($(this).prop('nodeName').toLowerCase() == 'input') {

                                //     $(this).on('change', function () {

                                //         if ($.trim($(this).val()) != '') {
                                //             // alert($(this).val());
                                //         } else {

                                //         }

                                //     });

                                // }

                                // if ($(this).prop('nodeName').toLowerCase() == 'textarea') {

                                //     $(this).on('change', function () {

                                //         if ($.trim($(this).val()) != '') {
                                //             // alert($(this).val());
                                //         } else {

                                //         }

                                //     });

                                // }


                            }

                            if ($(this).prev().prop('nodeName') != undefined && $(this).prev().prop('nodeName').toLowerCase() == 'option') {

                                var selectEl = $(this).parent();

                                if ($(selectEl).attr('form-end-initialised') == undefined) {
                                    // Set so only one event is mapped
                                    $(selectEl).attr('form-end-initialised', true);

                                    $(selectEl).on('change', function () {

                                        // Show
                                        var selectedOption = $(selectEl).children("option:selected");

                                        // $(_form).removeClass('was-validated');
                                        // $(_form).removeClass('form-spam-validated');

                                        // console.log(selectedOption);

                                        if ($(selectedOption).length > 0) {

                                            if ($(selectedOption).get(0).hasAttribute("form-end")) {

                                                $(_self.form).find('fieldset').hide();
                                                $(_self.form).find('fieldset').disabled = true;

                                                // Create a dynamic button to re-enable form
                                                var tt = $('<button type="button" class="btn btn-primary text-white mt-0">Go back</button>').on('click', function (e) {

                                                    e.preventDefault();

                                                    // Reset to first element
                                                    $(selectEl).val('').change();

                                                });

                                                var msg = $('<div class="form-finished-message" role="alert"><h4>Thank you for your interest</h4><p>' + $(selectedOption).attr('form-end') + '.</p></div>');

                                                $(msg).append(tt);

                                                $($(_self.form)).prepend(msg);

                                                // components.bs_modal.success('Thank you for your interest', '<p>'+$(selectedOption).attr('form-end')+'</p>');    

                                            }
                                            else {

                                                $(_self.form).find('.form-finished-message').remove();

                                                $(_self.form).find('fieldset').show();
                                                $(_self.form).find('fieldset').disabled = false;

                                            }

                                        }


                                    });

                                }


                            }

                        });

                    },

                    // Show group and fields
                    enableFieldGroups: function (_target) {

                        const _self = this;
                        _target = $(_self.form).find(_target);

                        _self.disableFieldGroups(_target);

                        // alert($(_target).length);

                        if ($(_target).length > 0) {
                            $(_target).removeAttr('hidden');
                            $(_target).prop('hidden', false);
                            _self.enableFields(_target);
                        }

                    },

                    // Hide group and fields
                    disableFieldGroups: function (_target) {
                        const _self = this;
                        _target = $(_self.form).find("[id^='form-fields-branching-']");

                        // alert($(_target).length);

                        if ($(_target).length > 0) {
                            $(_target).attr('hidden');
                            $(_target).prop('hidden', true);
                            _self.disableFields(_target);
                        }

                    },

                    // Enable various form fields
                    enableFields: function (_target) {

                        const _self = this;

                        var elements = $(_target).find('input,textarea,select,option');

                        if ($(elements).length == 0) {
                            return;
                        }

                        $(elements).each(function () {

                            if ($(this).prev().prop('nodeName') != undefined && $(this).prev().prop('nodeName').toLowerCase() == 'option') {

                                $(this).parent().prop('disabled', false);
                            } else {
                                $(this).prop('disabled', false);
                            }

                        });

                    },

                    // Disable various form fields
                    disableFields: function (_target) {

                        const _self = this;

                        var elements = $(_target).find('input,textarea,select,option');

                        if ($(elements).length == 0) {
                            return;
                        }

                        $(elements).each(function () {

                            if ($(this).prev().prop('nodeName') != undefined && $(this).prev().prop('nodeName').toLowerCase() == 'option') {

                                $(this).parent().prop('disabled', true);
                            } else {
                                $(this).prop('disabled', true);
                            }

                        });

                    },

                },

                // Generic Contact form
                contact: {

                    selector: "form#contact-form", // Jquery selector

                    // Collect forms
                    elements: function (element) {
                        // Get all tbe                    
                        var forms = $(element).length != 0 ? $(element) : $(this.selector);

                        if ($(forms).length > 0) {
                            return forms;
                        } else {
                            return null;
                        }

                    },

                    // Initialisation
                    init: function () {

                        const _self = this;

                        var forms = this.elements();
                        if (forms === null) return false;

                        // Submit function
                        _self.submit();

                        // Pre-popualate form fields 
                        // _self.updateFormFields();

                    },

                    // Enable or disable submit button, use during ajax 
                    disableFormFields: function (disabled = true, label = 'Please wait...') {

                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).find("[type='submit']").each(function () {

                            // Show/hide spinner and button text
                            if (disabled) {

                                let labelDefault = $(this).attr("aria-label");
                                $(this).attr("aria-label-default", labelDefault);
                                $(this).attr("aria-label", label);

                                $(this).find(".label").hide();
                                $(this).find(".spinner-border").prop("hidden", false);
                            } else {

                                let labelRevert = $(this).attr("aria-label-default");
                                labelRevert = labelRevert != "" ? labelRevert : $(this).attr("aria-label-default");
                                $(this).attr("aria-label", labelRevert);

                                $(this).find(".label").show();
                                $(this).find(".spinner-border").prop("hidden", true);
                            }

                        });



                    },

                    // Updates form fields (input fields) with the data stored in browser
                    updateFormFields: function (data) {

                        var forms = this.elements();
                        if (forms === null) return;

                        var data = data != null && data != "" ? data : get_storage(global.storage_names.user_contact);

                        if (data != null && data != "") {

                            $.each(data, function (key, value) {

                                var formFields = $(forms).find("[name='" + key + "']");

                                if ($(formFields).length > 0) {

                                    $(formFields).val(value);
                                }
                            });

                            return true;

                        } else {
                            return false;
                        }


                    },



                    // Form submit process
                    submit: function () {

                        const _self = this;
                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).each(function (index, form) {

                            // Submit Event
                            $(this).on("submit", function (e) {

                                // Return immediately if not validated
                                if (e.isDefaultPrevented()) {
                                    return false;
                                }

                                if (global.google_recaptcha != undefined && global.google_recaptcha != '') {

                                    grecaptcha.ready(function () {
                                        grecaptcha.execute(global.google_recaptcha, { action: 'submit' }).then(function (token) {

                                            // When toke is Google Recaptcha token is ready, call ajax function
                                            $.when(

                                                $.ajax({
                                                    url: global.ajax_endpoints.post_contact_form,
                                                    method: "POST",
                                                    dataType: "json",
                                                    data: $(form).serialize(),
                                                    statusCode: {
                                                        404: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Request method not found");
                                                            }
                                                        },
                                                        406: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Some data missing from the form");
                                                            }
                                                        },
                                                        503: function () {
                                                            console.log("Email did not send or other server related error while processing the request");
                                                        }
                                                    },
                                                    beforeSend: function (xhr) {
                                                        // console.log("Site Key: "+global.google_recaptcha);
                                                        // console.log("Token: "+token);
                                                        xhr.setRequestHeader('X-Recaptcha-Token', token);

                                                        // console.log( global.wp_nonce );
                                                        if (global.wp_nonce != undefined && global.wp_nonce != "") {
                                                            xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce);
                                                        }
                                                        // Disable submit button
                                                        _self.disableFormFields(true);
                                                    },
                                                    complete: function () {
                                                        $(form).removeClass('was-validated');
                                                        // Enable submit button
                                                        _self.disableFormFields(false);
                                                    },

                                                })

                                            ).then(

                                                function (response, textStatus, jqXHR) {

                                                    // Success
                                                    if (response.success !== undefined && !!response.success) {

                                                        // Store user form data and allow reuse for other contacts
                                                        if (!!response.user) {
                                                            set_storage(global.storage_names.user_contact, {
                                                                'first_name': response.user.first_name,
                                                                'last_name': response.user.last_name,
                                                                'phone': response.user.phone,
                                                                'email': response.user.email,
                                                            });
                                                        }

                                                        // DEBUG RELATED
                                                        if (global.debug_mode) {
                                                            console.log(response);
                                                        }

                                                        components.gtm.dataLayerGAEventTracking('Forms', 'Submit', 'Contact Form - ' + response.user.contact_type);

                                                        components.bs_modal.success('Thank you for contacting us!', '<p>Thank you for contacting us ' + response.user.first_name + '. We will be in touch shortly.</p>');

                                                        $(form)[0].reset();

                                                        return false;

                                                    }


                                                    if (global.debug_mode) {
                                                        console.log(response);
                                                    }


                                                    // Spam Filter exists and failed
                                                    if (global.google_recaptcha != undefined && global.google_recaptcha != '' && response.spam_failed !== undefined && !!response.spam_failed) {
                                                        // Show error if the response was unsuccessful
                                                        components.bs_modal.failed('Something not quite right!', '<p>Our spam filter has detected abnomalities with your form submission. Please try again later or kindly call us directly should the problem persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                        return false;
                                                    }

                                                    // Show error if the response was unsuccessful
                                                    components.bs_modal.failed('We\'re unable to submit the form', '<p>There was some issue trying to submit the form. Please try again later or kindly call us should the issue persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                    return false;


                                                }

                                            );

                                        });
                                    });

                                }

                                // Prevent Browser Default
                                return false;

                            });

                        });

                    }

                },

                // Mailchimp Subscription
                mailchimp_subscription: {

                    selector: "form#job-alert-subscription", // Jquery selector

                    // Collect forms
                    elements: function (element) {
                        // Get all tbe                    
                        var forms = $(element).length != 0 ? $(element) : $(this.selector);

                        if ($(forms).length > 0) {
                            return forms;
                        } else {
                            return null;
                        }

                    },

                    // Initialisation
                    init: function () {

                        const _self = this;

                        var forms = this.elements();
                        if (forms === null) return false;

                        // Submit function
                        _self.submit();

                        // Pre-popualate form fields 
                        // _self.updateFormFields();

                    },

                    // Enable or disable submit button, use during ajax 
                    disableFormFields: function (disabled = true, label = 'Please wait...') {

                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).find("[type='submit']").each(function () {

                            // Show/hide spinner and button text
                            if (disabled) {

                                let labelDefault = $(this).attr("aria-label");
                                $(this).attr("aria-label-default", labelDefault);
                                $(this).attr("aria-label", label);

                                $(this).find(".label").hide();
                                $(this).find(".spinner-border").prop("hidden", false);
                            } else {

                                let labelRevert = $(this).attr("aria-label-default");
                                labelRevert = labelRevert != "" ? labelRevert : $(this).attr("aria-label-default");
                                $(this).attr("aria-label", labelRevert);

                                $(this).find(".label").show();
                                $(this).find(".spinner-border").prop("hidden", true);
                            }

                        });



                    },


                    // Form submit process
                    submit: function () {

                        const _self = this;
                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).each(function (index, form) {

                            // Submit Event
                            $(this).on("submit", function (e) {

                                // Return immediately if not validated
                                if (e.isDefaultPrevented()) {
                                    return false;
                                }

                                if (global.google_recaptcha != undefined && global.google_recaptcha != '') {

                                    grecaptcha.ready(function () {
                                        grecaptcha.execute(global.google_recaptcha, { action: 'submit' }).then(function (token) {

                                            // When token is Google Recaptcha token is ready, call ajax function
                                            $.when(

                                                $.ajax({
                                                    url: global.ajax_endpoints.post_mailchimp_subscription,
                                                    method: "POST",
                                                    dataType: "json",
                                                    data: $(form).serialize(),
                                                    statusCode: {
                                                        404: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Request method not found");
                                                            }
                                                        },
                                                        406: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Some data missing from the form");
                                                            }
                                                        },
                                                        503: function () {
                                                            console.log("Email did not send or other server related error while processing the request");
                                                        }
                                                    },
                                                    beforeSend: function (xhr) {
                                                        // console.log("Site Key: "+global.google_recaptcha);
                                                        // console.log("Token: "+token);
                                                        xhr.setRequestHeader('X-Recaptcha-Token', token);

                                                        // console.log( global.wp_nonce );
                                                        // if( global.wp_nonce != undefined && global.wp_nonce != ""){
                                                        //     xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce );
                                                        // }

                                                        // Disable submit button
                                                        _self.disableFormFields(true);
                                                    },
                                                    complete: function () {
                                                        $(form).removeClass('was-validated');
                                                        // Enable submit button
                                                        _self.disableFormFields(false);
                                                    },

                                                })

                                            ).then(

                                                function (response, textStatus, jqXHR) {

                                                    // Success
                                                    if (response.success !== undefined && !!response.success) {

                                                        // DEBUG RELATED
                                                        if (global.debug_mode) {
                                                            console.log(response);
                                                        }

                                                        components.gtm.dataLayerGAEventTracking('Forms', 'Submit', 'Job Alert Form');

                                                        components.bs_modal.success('Successfully subscribed to job alerts!', '<p>' + response.message + '</p>');

                                                        $(form)[0].reset();

                                                        return false;

                                                    }


                                                    if (global.debug_mode) {
                                                        console.log(response);
                                                    }


                                                    // Spam Filter exists and failed
                                                    if (global.google_recaptcha != undefined && global.google_recaptcha != '' && response.spam_failed !== undefined && !!response.spam_failed) {
                                                        // Show error if the response was unsuccessful
                                                        components.bs_modal.failed('Something not quite right!', '<p>Our spam filter has detected abnomalities with your form submission. Please try again later or kindly call us directly should the problem persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                        return false;
                                                    }

                                                    // Show error if the response was unsuccessful
                                                    components.bs_modal.failed('We\'re unable to subscribe you to our job alerts!', '<p>' + response.message + '</p>');

                                                    return false;


                                                }

                                            );

                                        });
                                    });

                                }

                                // Prevent Browser Default
                                return false;

                            });

                        });

                    }

                },

                // DoneSafe Application Form
                job_application: {

                    selector: "form#job-application-form", // Jquery selector

                    // Collect forms
                    elements: function (element) {
                        // Get all tbe                    
                        var forms = $(element).length != 0 ? $(element) : $(this.selector);

                        if ($(forms).length > 0) {
                            return forms;
                        } else {
                            return null;
                        }

                    },

                    // Initialisation
                    init: function () {

                        const _self = this;

                        var forms = this.elements();
                        if (forms === null) return false;

                        // Submit function
                        _self.submit();

                        // Pre-popualate form fields 
                        // _self.updateFormFields();


                        $(forms).each(function () {

                            let _form = $(this);

                            let _formBtn = $(_form).find('[type="submit"]');

                            // Form branching
                            components.forms.formBranching.init(_form);

                            // Form branching
                            components.forms.formEnd.init(_form);

                            // let vehicle_status_fieldset = $(this).find('fieldset[name="vehicle-info"]');
                            let vehicle_info_fieldset = $(this).find('fieldset[name="vehicle-info"]');
                            let vehicle_profile_fieldset = $(this).find('fieldset[name="vehicle-profile"]');


                            // Reset everything withing fieldset on change
                            $(forms).find("[name='vehicle_status']").on("change", function () {

                                let changedValue = $(this).val();

                                if (changedValue == 'Willing to buy a vehicle' || changedValue == '') {

                                    $(vehicle_info_fieldset).fadeOut();
                                    // $(vehicle_info_fieldset).get(0).disabled = true;

                                } else {

                                    $(vehicle_info_fieldset).fadeIn();
                                    // $(vehicle_info_fieldset).get(0).disabled = false;
                                }

                            }).trigger('change');

                            // Reset everything withing fieldset on change
                            $(forms).find("[name='vehicle_less_than_8yrs']").on("change", function () {

                                let changedValue = $(this).val();

                                if (changedValue !== 'yes') {

                                    if($(vehicle_profile_fieldset).length > 0){
                                        $(vehicle_profile_fieldset).fadeOut();
                                        $(vehicle_profile_fieldset)[0].disabled = true;
    
                                        // Enable child select fields
                                        $(vehicle_profile_fieldset).find('select input').each(function () {
                                            $(this)[0].disabled = true;
                                        });
                                    }


                                } else {


                                    if($(vehicle_profile_fieldset).length > 0){
                                        $(vehicle_profile_fieldset).fadeIn();
                                        $(vehicle_profile_fieldset)[0].disabled = false;

                                        // Disable child select fields
                                        $(vehicle_profile_fieldset).find('select input').each(function () {
                                            $(this)[0].disabled = false;
                                        });
                                    }    

                                }

                            }).trigger('change');

                        });

                    },

                    // Enable or disable submit button, use during ajax 
                    disableFormFields: function (disabled = true, label = 'Please wait...') {

                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).find("[type='submit']").each(function () {

                            // Show/hide spinner and button text
                            if (disabled) {

                                let labelDefault = $(this).attr("aria-label");
                                $(this).attr("aria-label-default", labelDefault);
                                $(this).attr("aria-label", label);

                                $(this).find(".label").hide();
                                $(this).find(".spinner-border").prop("hidden", false);
                            } else {

                                let labelRevert = $(this).attr("aria-label-default");
                                labelRevert = labelRevert != "" ? labelRevert : $(this).attr("aria-label-default");
                                $(this).attr("aria-label", labelRevert);

                                $(this).find(".label").show();
                                $(this).find(".spinner-border").prop("hidden", true);
                            }

                        });

                    },

                    // Form submit process
                    submit: function () {

                        const _self = this;
                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).each(function (index, form) {

                            // Submit Event
                            $(this).on("submit", function (e) {

                                // Return immediately if not validated
                                if (e.isDefaultPrevented()) {

                                    return false;
                                }

                                if (global.google_recaptcha != undefined && global.google_recaptcha != '') {

                                    grecaptcha.ready(function () {
                                        grecaptcha.execute(global.google_recaptcha, { action: 'submit' }).then(function (token) {

                                            // When token is Google Recaptcha token is ready, call ajax function
                                            $.when(

                                                $.ajax({
                                                    url: global.ajax_endpoints.post_job_application,
                                                    method: "POST",
                                                    dataType: "json",
                                                    data: $(form).serialize(),
                                                    statusCode: {
                                                        404: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Request method not found");
                                                            }
                                                        },
                                                        406: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Some data missing from the form");
                                                            }
                                                        },
                                                        503: function () {
                                                            console.log("Email did not send or other server related error while processing the request");
                                                        }
                                                    },
                                                    beforeSend: function (xhr) {

                                                        // DEBUG data
                                                        // if ( global.debug_mode) {
                                                        //     console.log( $(this).serializeArray() ) ;
                                                        // }

                                                        // console.log("Site Key: "+global.google_recaptcha);
                                                        // console.log("Token: "+token);
                                                        xhr.setRequestHeader('X-Recaptcha-Token', token);

                                                        // console.log( global.wp_nonce );
                                                        // if( global.wp_nonce != undefined && global.wp_nonce != ""){
                                                        //     xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce );
                                                        // }

                                                        // Disable submit button
                                                        _self.disableFormFields(true);
                                                    },
                                                    complete: function () {
                                                        $(form).removeClass('was-validated');
                                                        // Enable submit button
                                                        _self.disableFormFields(false);
                                                    },

                                                })

                                            ).then(

                                                function (response, textStatus, jqXHR) {

                                                    // Success
                                                    if (response.success !== undefined && !!response.success) {

                                                        // DEBUG RELATED
                                                        if (global.debug_mode) {
                                                            console.log(response);
                                                        }

                                                        components.gtm.dataLayerGAEventTracking('Forms', 'Submit', 'Job Application');

                                                        components.bs_modal.success('Successfully submitted your application!', '<p>' + response.message + '</p>');

                                                        // DISABLE TO EASE TESTING MULTIPLE ENTRIES
                                                        $(form)[0].reset();

                                                        return false;

                                                    }


                                                    if (global.debug_mode) {
                                                        console.log(response);
                                                    }


                                                    // Spam Filter exists and failed
                                                    if (global.google_recaptcha != undefined && global.google_recaptcha != '' && response.spam_failed !== undefined && !!response.spam_failed) {
                                                        // Show error if the response was unsuccessful
                                                        components.bs_modal.failed('Something not right!', '<p>Our spam filter has detected abnomalities with your form submission. Please try again later or kindly call us directly should the problem persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                        return false;
                                                    }

                                                    // Show error if the response was unsuccessful
                                                    components.bs_modal.failed('We\'re unable to submit your application. Please try again later.', '<p>' + response.message + '</p>');

                                                    return false;


                                                }

                                            );

                                        });
                                    });

                                }

                                // Prevent Browser Default
                                return false;

                            });

                        });

                    }

                },

                // DoneSafe Expression Of Interest Form
                job_eoi: {

                    selector: "form#job-expression-of-interest-form", // Jquery selector

                    // Collect forms
                    elements: function (element) {
                        // Get all tbe                    
                        var forms = $(element).length != 0 ? $(element) : $(this.selector);

                        if ($(forms).length > 0) {
                            return forms;
                        } else {
                            return null;
                        }

                    },

                    // Initialisation
                    init: function () {

                        const _self = this;

                        var forms = this.elements();
                        if (forms === null) return false;

                        // Submit function
                        _self.submit();

                        // Pre-popualate form fields 
                        // _self.updateFormFields();

                    },

                    // Enable or disable submit button, use during ajax 
                    disableFormFields: function (disabled = true, label = 'Please wait...') {

                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).find("[type='submit']").each(function () {

                            // Show/hide spinner and button text
                            if (disabled) {

                                let labelDefault = $(this).attr("aria-label");
                                $(this).attr("aria-label-default", labelDefault);
                                $(this).attr("aria-label", label);

                                $(this).find(".label").hide();
                                $(this).find(".spinner-border").prop("hidden", false);
                            } else {

                                let labelRevert = $(this).attr("aria-label-default");
                                labelRevert = labelRevert != "" ? labelRevert : $(this).attr("aria-label-default");
                                $(this).attr("aria-label", labelRevert);

                                $(this).find(".label").show();
                                $(this).find(".spinner-border").prop("hidden", true);
                            }

                        });

                    },

                    // Form submit process
                    submit: function () {

                        const _self = this;
                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).each(function (index, form) {

                            // Submit Event
                            $(this).on("submit", function (e) {

                                // Return immediately if not validated
                                if (e.isDefaultPrevented()) {
                                    return false;
                                }

                                if (global.google_recaptcha != undefined && global.google_recaptcha != '') {

                                    grecaptcha.ready(function () {
                                        grecaptcha.execute(global.google_recaptcha, { action: 'submit' }).then(function (token) {

                                            // When token is Google Recaptcha token is ready, call ajax function
                                            $.when(

                                                $.ajax({
                                                    url: global.ajax_endpoints.post_job_eoi_application,
                                                    method: "POST",
                                                    dataType: "json",
                                                    data: $(form).serialize(),
                                                    statusCode: {
                                                        404: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Request method not found");
                                                            }
                                                        },
                                                        406: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Some data missing from the form");
                                                            }
                                                        },
                                                        503: function () {
                                                            console.log("Email did not send or other server related error while processing the request");
                                                        }
                                                    },
                                                    beforeSend: function (xhr) {

                                                        // DEBUG data
                                                        // if ( global.debug_mode) {
                                                        //     console.log( $(this).serializeArray() ) ;
                                                        // }

                                                        // console.log("Site Key: "+global.google_recaptcha);
                                                        // console.log("Token: "+token);
                                                        xhr.setRequestHeader('X-Recaptcha-Token', token);

                                                        // console.log( global.wp_nonce );
                                                        // if( global.wp_nonce != undefined && global.wp_nonce != ""){
                                                        //     xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce );
                                                        // }

                                                        // Disable submit button
                                                        _self.disableFormFields(true);

                                                    },
                                                    complete: function () {
                                                        $(form).removeClass('was-validated');
                                                        // Enable submit button
                                                        _self.disableFormFields(false);
                                                    },

                                                })

                                            ).then(

                                                function (response, textStatus, jqXHR) {

                                                    // Success
                                                    if (response.success !== undefined && !!response.success) {

                                                        // DEBUG RELATED
                                                        if (global.debug_mode) {
                                                            console.log(response);
                                                        }

                                                        components.gtm.dataLayerGAEventTracking('Forms', 'Submit', 'Job Expression Of Interest');

                                                        components.bs_modal.success('Successfully submitted your form!', '<p>' + response.message + '</p>');

                                                        // DISABLE TO EASE TESTING MULTIPLE ENTRIES
                                                        $(form)[0].reset();

                                                        return false;

                                                    }


                                                    if (global.debug_mode) {
                                                        console.log(response);
                                                    }


                                                    // Spam Filter exists and failed
                                                    if (global.google_recaptcha != undefined && global.google_recaptcha != '' && response.spam_failed !== undefined && !!response.spam_failed) {
                                                        // Show error if the response was unsuccessful
                                                        components.bs_modal.failed('Something not right!', '<p>Our spam filter has detected abnomalities with your form submission. Please try again later or kindly call us directly should the problem persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                        return false;
                                                    }

                                                    // Show error if the response was unsuccessful
                                                    components.bs_modal.failed('We\'re unable to submit your form. Please try again later.', '<p>' + response.message + '</p>');

                                                    return false;


                                                }

                                            );

                                        });
                                    });

                                }

                                // Prevent Browser Default
                                return false;

                            });

                        });

                    }

                },

                // DoneSafe Client Enquiry/Lead Form
                client_enquiry: {

                    selector: "form#client-enquiry-form", // Jquery selector

                    // Collect forms
                    elements: function (element) {
                        // Get all tbe                    
                        var forms = $(element).length != 0 ? $(element) : $(this.selector);

                        if ($(forms).length > 0) {
                            return forms;
                        } else {
                            return null;
                        }

                    },

                    // Initialisation
                    init: function () {

                        const _self = this;

                        var forms = this.elements();
                        if (forms === null) return false;

                        // Submit function
                        _self.submit();

                        // Pre-popualate form fields 
                        // _self.updateFormFields();

                    },

                    // Enable or disable submit button, use during ajax 
                    disableFormFields: function (disabled = true, label = 'Please wait...') {

                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).find("[type='submit']").each(function () {

                            // Show/hide spinner and button text
                            if (disabled) {

                                let labelDefault = $(this).attr("aria-label");
                                $(this).attr("aria-label-default", labelDefault);
                                $(this).attr("aria-label", label);

                                $(this).find(".label").hide();
                                $(this).find(".spinner-border").prop("hidden", false);
                            } else {

                                let labelRevert = $(this).attr("aria-label-default");
                                labelRevert = labelRevert != "" ? labelRevert : $(this).attr("aria-label-default");
                                $(this).attr("aria-label", labelRevert);

                                $(this).find(".label").show();
                                $(this).find(".spinner-border").prop("hidden", true);
                            }

                        });

                    },

                    // Form submit process
                    submit: function () {

                        const _self = this;
                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).each(function (index, form) {

                            // Submit Event
                            $(this).on("submit", function (e) {

                                // Return immediately if not validated
                                if (e.isDefaultPrevented()) {
                                    return false;
                                }

                                if (global.google_recaptcha != undefined && global.google_recaptcha != '') {

                                    grecaptcha.ready(function () {
                                        grecaptcha.execute(global.google_recaptcha, { action: 'submit' }).then(function (token) {

                                            // When token is Google Recaptcha token is ready, call ajax function
                                            $.when(

                                                $.ajax({
                                                    url: global.ajax_endpoints.post_donesafe_client_enquiry_form,
                                                    method: "POST",
                                                    dataType: "json",
                                                    data: $(form).serialize(),
                                                    statusCode: {
                                                        404: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Request method not found");
                                                            }
                                                        },
                                                        406: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Some data missing from the form");
                                                            }
                                                        },
                                                        503: function () {
                                                            console.log("Email did not send or other server related error while processing the request");
                                                        }
                                                    },
                                                    beforeSend: function (xhr) {

                                                        // DEBUG data
                                                        // if ( global.debug_mode) {
                                                        //     console.log( $(this).serializeArray() ) ;
                                                        // }

                                                        // console.log("Site Key: "+global.google_recaptcha);
                                                        // console.log("Token: "+token);
                                                        xhr.setRequestHeader('X-Recaptcha-Token', token);

                                                        // console.log( global.wp_nonce );
                                                        // if( global.wp_nonce != undefined && global.wp_nonce != ""){
                                                        //     xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce );
                                                        // }

                                                        // Disable submit button
                                                        _self.disableFormFields(true);

                                                    },
                                                    complete: function () {
                                                        $(form).removeClass('was-validated');
                                                        // Enable submit button
                                                        _self.disableFormFields(false);
                                                    },

                                                })

                                            ).then(

                                                function (response, textStatus, jqXHR) {

                                                    // Success
                                                    if (response.success !== undefined && !!response.success) {

                                                        // DEBUG RELATED
                                                        if (global.debug_mode) {
                                                            console.log(response);
                                                        }

                                                        components.gtm.dataLayerGAEventTracking('Forms', 'Submit', 'Client Enquiry/Lead');

                                                        components.bs_modal.success('Successfully submitted your form!', '<p>' + response.message + '</p>');

                                                        // DISABLE TO EASE TESTING MULTIPLE ENTRIES
                                                        $(form)[0].reset();

                                                        return false;

                                                    }


                                                    if (global.debug_mode) {
                                                        console.log(response);
                                                    }


                                                    // Spam Filter exists and failed
                                                    if (global.google_recaptcha != undefined && global.google_recaptcha != '' && response.spam_failed !== undefined && !!response.spam_failed) {
                                                        // Show error if the response was unsuccessful
                                                        components.bs_modal.failed('Something not right!', '<p>Our spam filter has detected abnomalities with your form submission. Please try again later or kindly call us directly should the problem persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                        return false;
                                                    }

                                                    // Show error if the response was unsuccessful
                                                    components.bs_modal.failed('We\'re unable to submit your form. Please try again later.', '<p>' + response.message + '</p>');

                                                    return false;


                                                }

                                            );

                                        });
                                    });

                                }

                                // Prevent Browser Default
                                return false;

                            });

                        });

                    }

                },

                // Get A Quote popup form
                get_a_quote: {

                    selector: "form#get-a-quote-form", // Jquery selector

                    // Collect forms
                    elements: function (element) {
                        // Get all tbe                    
                        var forms = $(element).length != 0 ? $(element) : $(this.selector);

                        if ($(forms).length > 0) {
                            return forms;
                        } else {
                            return null;
                        }

                    },

                    // Initialisation
                    init: function () {

                        const _self = this;

                        var forms = this.elements();
                        if (forms === null) return false;

                        // Submit function
                        _self.submit();

                        // Pre-popualate form fields 
                        // _self.updateFormFields();

                    },

                    // Enable or disable submit button, use during ajax 
                    disableFormFields: function (disabled = true, label = 'Please wait...') {

                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).find("[type='submit']").each(function () {

                            // Show/hide spinner and button text
                            if (disabled) {

                                let labelDefault = $(this).attr("aria-label");
                                $(this).attr("aria-label-default", labelDefault);
                                $(this).attr("aria-label", label);

                                $(this).find(".label").hide();
                                $(this).find(".spinner-border").prop("hidden", false);
                            } else {

                                let labelRevert = $(this).attr("aria-label-default");
                                labelRevert = labelRevert != "" ? labelRevert : $(this).attr("aria-label-default");
                                $(this).attr("aria-label", labelRevert);

                                $(this).find(".label").show();
                                $(this).find(".spinner-border").prop("hidden", true);
                            }

                        });



                    },

                    // Updates form fields (input fields) with the data stored in browser
                    updateFormFields: function (data) {

                        var forms = this.elements();
                        if (forms === null) return;

                        var data = data != null && data != "" ? data : get_storage(global.storage_names.user_contact);

                        if (data != null && data != "") {

                            $.each(data, function (key, value) {

                                var formFields = $(forms).find("[name='" + key + "']");

                                if ($(formFields).length > 0) {

                                    $(formFields).val(value);
                                }
                            });

                            return true;

                        } else {
                            return false;
                        }


                    },



                    // Form submit process
                    submit: function () {

                        const _self = this;
                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).each(function (index, form) {

                            // Submit Event
                            $(this).on("submit", function (e) {

                                // Return immediately if not validated
                                if (e.isDefaultPrevented()) {
                                    return false;
                                }

                                if (global.google_recaptcha != undefined && global.google_recaptcha != '') {

                                    grecaptcha.ready(function () {
                                        grecaptcha.execute(global.google_recaptcha, { action: 'submit' }).then(function (token) {

                                            // When toke is Google Recaptcha token is ready, call ajax function
                                            $.when(

                                                $.ajax({
                                                    url: global.ajax_endpoints.post_get_a_quote_form,
                                                    method: "POST",
                                                    dataType: "json",
                                                    data: $(form).serialize(),
                                                    statusCode: {
                                                        404: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Request method not found");
                                                            }
                                                        },
                                                        406: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Some data missing from the form");
                                                            }
                                                        },
                                                        503: function () {
                                                            console.log("Email did not send or other server related error while processing the request");
                                                        }
                                                    },
                                                    beforeSend: function (xhr) {
                                                        // console.log("Site Key: "+global.google_recaptcha);
                                                        // console.log("Token: "+token);
                                                        xhr.setRequestHeader('X-Recaptcha-Token', token);

                                                        // console.log( global.wp_nonce );
                                                        if (global.wp_nonce != undefined && global.wp_nonce != "") {
                                                            xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce);
                                                        }
                                                        // Disable submit button
                                                        _self.disableFormFields(true);
                                                    },
                                                    complete: function () {
                                                        $(form).removeClass('was-validated');
                                                        // Enable submit button
                                                        _self.disableFormFields(false);
                                                    },

                                                })

                                            ).then(

                                                function (response, textStatus, jqXHR) {

                                                    // Success
                                                    if (response.success !== undefined && !!response.success) {

                                                        // Store user form data and allow reuse for other contacts
                                                        if (!!response.user) {
                                                            set_storage(global.storage_names.user_contact, {
                                                                'first_name': response.user.first_name,
                                                                'last_name': response.user.last_name,
                                                                'phone': response.user.phone,
                                                                'email': response.user.email,
                                                            });
                                                        }

                                                        // DEBUG RELATED
                                                        if (global.debug_mode) {
                                                            console.log(response);
                                                        }

                                                        components.gtm.dataLayerGAEventTracking('Forms', 'Submit', 'Get A Quote - ' + response.user.contact_type);

                                                        // Hide popup form
                                                        $('#modal-get-a-quote').modal('hide');

                                                        components.bs_modal.success('Thank you for contacting us!', '<p>Thank you for contacting us ' + response.user.first_name + '. We will be in touch shortly.</p>');

                                                        $(form)[0].reset();

                                                        return false;

                                                    }


                                                    if (global.debug_mode) {
                                                        console.log(response);
                                                    }


                                                    // Spam Filter exists and failed
                                                    if (global.google_recaptcha != undefined && global.google_recaptcha != '' && response.spam_failed !== undefined && !!response.spam_failed) {
                                                        // Show error if the response was unsuccessful
                                                        components.bs_modal.failed('Something not quite right!', '<p>Our spam filter has detected abnomalities with your form submission. Please try again later or kindly call us directly should the problem persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                        return false;
                                                    }

                                                    // Show error if the response was unsuccessful
                                                    components.bs_modal.failed('We\'re unable to submit the form', '<p>There was some issue trying to submit the form. Please try again later or kindly call us should the issue persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                    return false;


                                                }

                                            );

                                        });
                                    });

                                }

                                // Prevent Browser Default
                                return false;

                            });

                        });

                    }

                },


            },

            geo: {

                /**
                 * Get User geolocation 
                 */
                get_user_geolocation: function () {

                    // Try HTML5 geolocation.
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                const pos = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude,
                                };

                                return pos;
                            }
                        );
                    }

                    return false;

                },
            },

            gtm: {

                /**
                 *  Google Tag Manager
                 */
                dataLayerGAEventTracking: function (category, action, label, value) {

                    window.dataLayer = window.dataLayer || [];

                    // Ensure GTM is load in initiated
                    if (typeof window.dataLayer !== 'undefined') {
                        // dataLayer.push({'eventCategory': 'Find A Workout - View Provider Details', 'eventAction' : 'Click', , 'eventLabel': 'Club: TennisWorld | Coach: Matt Ebden' });
                        window.dataLayer.push({
                            'event': 'ga_event',
                            'eventCategory': category,
                            'eventAction': action,
                            'eventLabel': label,
                            'eventValue': value
                        });

                        // console.log({
                        //     'event': 'ga_event', 
                        //     'eventCategory': category, 
                        //     'eventAction': action, 
                        //     'eventLabel': label, 
                        //     'eventValue': value 
                        // });

                    }


                },

            },

            // Create modal for use for confirmation or error
            bs_modal: {

                success: function (title = "Form successfully submitted!", content = '') {

                    title = title != "" ? title : "";

                    let modal = $('\
                    <div class="modal contact-form-alert fade" tabindex="-1" aria-hidden="true">\
                            <div class="modal-dialog modal-dialog-centered">\
                                <div class="modal-content">\
                                    <div class="modal-header bg-primary">\
                                        <h5 class="modal-title text-light">'+ title + '</h5>\
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                                            <span aria-hidden="true">&times;</span>\
                                        </button>\
                                    </div>\
                                    <div class="modal-body">\
                                        '+ content + ' \
                                    </div> \
                                    <div class="modal-footer"> \
                                        <button type="button" class="btn btn-primary mx-auto" data-dismiss="modal">Close</button> \
                                    </div> \
                                </div> \
                            </div> \
                        </div> \
                    ');

                    $("body").append(modal);

                    $(modal).modal('show');

                },
                failed: function (title = "There was an issue", content = '') {

                    title = title != "" ? title : "";

                    let modal = $('\
                    <div class="modal contact-form-alert fade" tabindex="-1" aria-hidden="true">\
                            <div class="modal-dialog modal-dialog-centered">\
                                <div class="modal-content">\
                                    <div class="modal-header bg-primary">\
                                        <h5 class="modal-title text-light">'+ title + '</h5>\
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                                            <span aria-hidden="true">&times;</span>\
                                        </button>\
                                    </div>\
                                    <div class="modal-body">\
                                        '+ content + ' \
                                    </div> \
                                    <div class="modal-footer"> \
                                        <button type="button" class="btn btn-primary mx-auto" data-dismiss="modal">Close</button> \
                                    </div> \
                                </div> \
                            </div> \
                        </div> \
                    ');

                    $("body").append(modal);

                    $(modal).modal('show');

                },
                show: function (title = "", content = '') {

                    if (title == "" || content == "") return false;

                    title = title != "" ? title : "";

                    let modal = $('\
                    <div class="modal contact-form-alert fade" tabindex="-1" aria-hidden="true">\
                            <div class="modal-dialog modal-dialog-centered">\
                                <div class="modal-content">\
                                    <div class="modal-header bg-primary">\
                                        <h5 class="modal-title text-light">'+ title + '</h5>\
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                                            <span aria-hidden="true">&times;</span>\
                                        </button>\
                                    </div>\
                                    <div class="modal-body">\
                                        '+ content + ' \
                                    </div> \
                                    <div class="modal-footer"> \
                                        <button type="button" class="btn btn-primary mx-auto" data-dismiss="modal">Close</button> \
                                    </div> \
                                </div> \
                            </div> \
                        </div> \
                    ');

                    $("body").append(modal);

                    $(modal).modal('show');

                },
            },

            // Show/hide depending user activity on the page
            sticky_cta: {

                timer: 3000,

                selector: ".cta-bar", // Jquery selector

                element: [],

                // Collect forms
                elements: function (element) {
                    // Get all tbe                    
                    var cta_bar = $(element).length != 0 ? $(element) : $(this.selector);

                    if ($(cta_bar).length > 0) {
                        return cta_bar;
                    } else {
                        return null;
                    }

                },

                init : function () {

                    const _self = this;

                    var cta_bars = this.elements();
                    if (cta_bars === null || $(cta_bars).length == 0) return false;

                    $(cta_bars).each(function (i, el) {

                        _self.element = $(el);

                        // Attach a single event listener for user activity
                        const events = ['scroll', 'click','touchstart'];

                        events.forEach(event => {
                            window.addEventListener(event, () =>{

                                _self.resetInactivityTimer(_self.element)

                            }, { passive: true });
                        });
                    
                        // Initialize the timer
                        _self.resetInactivityTimer(_self.element);

                    });

                    
                },

                hideElement: function(el){
                    $(el).fadeOut();
                },

                showElement: function(el){
                    $(el).fadeIn();
                },

                resetInactivityTimer: function(el){

                    var _self = this;

                    _self.showElement(el);

                    clearTimeout(_self.timer);                    
                    _self.timer = setTimeout( () => { _self.hideElement(el) }  , 5000 );

                }

            },
           

        },
        /***********************************************************
        // PAGE SPECIFIC FUNCTIONS
        ***********************************************************/
        pages = function () {

            // Specific functions only required Use CSS classname on body tag
            if ($("body").hasClass('page-home')) { // Home or Front-Page
            }


            if ($("body").hasClass('page')) {

            }

            if ($("body").hasClass('post')) { // Post or Page

            }

            if ($("body").hasClass('search')) { // Search
                // Inline Code here ...
            }


            if ($("body").hasClass('archives') || $("body").hasClass('category')) { // Archives, Catgory, Tags, etc.

                $("a[ajax-load-posts]").on("click", function () {

                    console.log(global.ajax_endpoints.get_posts);

                    let _thisBtn = this;

                    let lastPostEntry = $("[id^='post-']").last();

                    if (!!$(lastPostEntry) && $(lastPostEntry).length > 0) {

                        let dateTimeElement = $(lastPostEntry).find("[timestamp]").last();

                        // Construct REST API QUERY parameters
                        var params = {
                            "cat_id": $(_thisBtn).attr('cat_id'),
                            "tax_id": $(_thisBtn).attr('tax_id'),
                            "end_date": $(dateTimeElement).attr("timestamp"),
                            "exclude_post": ($(lastPostEntry).attr("ID")).replace(/\D/g, "") // Exclude the last post not to be included as part of the results set
                        };

                        let xhr = $.ajax({

                            url: global.ajax_endpoints.get_posts,
                            method: "GET",
                            // dataType : "json",
                            data: params,
                            statusCode: {
                                404: function () {
                                    console.log("Error requesting posts data");
                                }
                            },
                            beforeSend: function () {
                                $(_thisBtn).attr("disabled", true);
                            }, // Disable all forms buttons
                            complete: function () {
                                $(_thisBtn).attr("disabled", false);
                            }, // Enable all forms submit buttons

                        });

                        $.when(xhr).done(function (response) {

                            if (response != "") {

                                if (response.post_count > 0) {

                                    // Load Handlebars template
                                    let HTMLTemplate = components.handlebars.render($("script#template-posts"));

                                    // Compile data into HTML using Handlebars
                                    let outputHTML = HTMLTemplate(response);

                                    // Inject HTML
                                    $(outputHTML).fadeOut();
                                    $(outputHTML).insertAfter(lastPostEntry);

                                    $(outputHTML).fadeIn();

                                    if (window.lazyLoadInstance) {
                                        window.lazyLoadInstance.update();
                                    }

                                    // console.log(outputHTML);

                                }

                                // Remove button when no more results
                                if (response.post_count == response.found_posts) {
                                    $(_thisBtn).remove();
                                }


                            }

                            // DEBUG RELATED
                            if (global.debug_mode) {
                                console.log(response);
                            }

                            return;

                        });

                    }

                });

            }

            if ($("body").hasClass('page-template-default')) {
                // Inline Code here ...
            }

            /* Other non-page specific functions for every page */




            //Clients carousel
            var owlClients = $('#client-carousel').owlCarousel({
                loop: true,
                margin: 60,
                nav: false,
                dots: true,
                lazyLoad: true,

                responsive: {
                    0: {
                        items: 1
                    },
                    600: {
                        items: 3
                    },
                    1000: {
                        items: 5
                    }
                }
            });

            //Call lazyload function on change
            owlClients.on('changed.owl.carousel', function (event) {
                window.lazyLoadInstance.update();
            })
            //End clients carousel


            //Industry carousel
            var owlIndustries = $('#industry-carousel').owlCarousel({
                loop: true,
                margin: 60,
                nav: false,
                dots: false,
                lazyLoad: true,

                responsive: {
                    0: {
                        items: 1,
                        dots: true
                    },
                    600: {
                        items: 2,
                        dots: true
                    },
                    992: {
                        items: 2
                    },
                    1400: {
                        items: 2
                    },
                    2000: {
                        items: 3
                    }
                }
            });
            //Call lazyload function on change
            owlIndustries.on('changed.owl.carousel', function (event) {
                window.lazyLoadInstance.update();
            });
            $('.carousel-ctrl-prev').on("click", function () {
                owlIndustries.trigger('prev.owl.carousel');
            })
            $('.carousel-ctrl-next').on("click", function () {
                owlIndustries.trigger('next.owl.carousel');
            })
            //End Industry carousel

            //Post carousel
            var owlPost = $('#post-carousel').owlCarousel({
                loop: false,
                margin: 60,
                nav: false,
                dots: false,
                lazyLoad: true,
                autoHeight: true,

                responsive: {
                    0: {
                        items: 1,
                        dots: true
                    },
                    600: {
                        items: 2
                    },
                    1000: {
                        items: 3
                    }
                }
            });

            //Call lazyload function on change
            owlPost.on('changed.owl.carousel', function (event) {
                window.lazyLoadInstance.update();
            })


            //Testimonial carousel
            var owlTestimonial = $('#testimonial-carousel').owlCarousel({
                loop: true,
                margin: 0,
                nav: false,
                dots: true,
                lazyLoad: true,
                items: 1
            });

            //Call lazyload function on change
            owlTestimonial.on('changed.owl.carousel', function (event) {
                window.lazyLoadInstance.update();
            });


            //team carousel
            var owlTeam = $('#team-carousel').owlCarousel({
                loop: false,
                margin: 55,
                nav: false,
                dots: true,
                lazyLoad: true,
                autoHeight: true,

                responsive: {
                    0: {
                        items: 1
                    },
                    600: {
                        items: 3
                    },
                    1000: {
                        items: 4
                    }
                }
            });

            //Call lazyload function on change
            owlTeam.on('changed.owl.carousel', function (event) {
                window.lazyLoadInstance.update();
            })






            // LESS THAN "MD"
            // if(global.breakpoint.index < 2){

            //     let serviceComparisonDesktop = $('#service-comparison-carousel');
            //     let serviceComparisonMobile = $('#service-comparison-carousel-mobile');

            //     if($(serviceComparisonDesktop).length == 1){

            //         // Clone a mobile version on load
            //         if( $(serviceComparisonMobile).length == 0){

            //             let serviceComparisonMobile = $(serviceComparisonDesktop).clone();
            //             serviceComparisonMobile.attr('id', 'service-comparison-carousel-mobile');

            //             serviceComparisonMobile.appendTo($(serviceComparisonDesktop).parent());

            //             // Remove Bootstrap Desktop classes to hide from mobile
            //             $(serviceComparisonMobile).removeClass("d-none d-md-block");
            //             serviceComparisonMobile.addClass("d-md-none");

            //             if( $(serviceComparisonMobile).hasClass('owl-carousel') == false){

            //                 $(serviceComparisonMobile).addClass("owl-carousel owl-theme");

            //                 let item = $(serviceComparisonMobile).find(".item"); 

            //                 if(item.length == 1){

            //                     item.removeClass('table-responsive');

            //                     item.clone().appendTo(serviceComparisonMobile);

            //                     //Service Comparison carousel
            //                     var owlServiceComparisons = $(serviceComparisonMobile).owlCarousel({
            //                         loop: false,
            //                         rewind: true,
            //                         margin:0,
            //                         nav:false,
            //                         dots:true,
            //                         lazyLoad: true,
            //                         items:1
            //                     });

            //                     //Call lazyload function on change
            //                     owlServiceComparisons.on('changed.owl.carousel', function(event) {
            //                         window.lazyLoadInstance.update();
            //                     });


            //                 }



            //             }


            //         }



            //     }


            // }





        },

        /***********************************************************
        // Other functions as required
        ***********************************************************/
        misc_func = function () { };


    /***********************************************************
    // Utility functions
    ***********************************************************/

    // Bootstrap breakpoint
    // @link https://unpkg.com/bootstrap-detect-breakpoint@1.0.8/src/bootstrap-detect-breakpoint.js
    bootstrapDetectBreakpoint = function () {
        // cache some values on first call
        if (!this.breakpointValues) {
            this.breakpointNames = ["xl", "lg", "md", "sm", "xs"]
            this.breakpointValues = []
            for (const breakpointName of this.breakpointNames) {
                this.breakpointValues[breakpointName] = window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-' + breakpointName)
            }
        }
        let i = this.breakpointNames.length
        for (const breakpointName of this.breakpointNames) {
            i--
            if (window.matchMedia("(min-width: " + this.breakpointValues[breakpointName] + ")").matches) {
                return { name: breakpointName, index: i }
            }
        }
        return null
    };

    // Utility method to get browser data
    get_storage = function (storageName, is_persistentStorage = true) {

        if (storageName != "") {

            // Store data permenantly or temporarily browser tab/window session
            if (is_persistentStorage == true) {
                // LocalStorage
                storageData = window.localStorage.getItem(storageName);

            } else {
                // SessionStorage
                storageData = window.sessionStorage.getItem(storageName);
            }

            if (storageData != null || storageData != "undefined") {

                // Always try to return as data as JS object if JSON or other data types
                try {
                    return JSON.parse(storageData);
                } catch (e) {
                    return storageData;
                }
            } else {
                return false;
            }

        }
        else {
            return false;
        }

    };

    // Utility method to store browser data
    set_storage = function (storageName, storageData, is_persistentStorage = true) {

        if (storageName != "") {

            // Always assume data is for JSON and escape data were necessary
            var storageData = JSON.stringify(storageData);

            // Store data permenantly or temporarily browser tab/window session
            if (is_persistentStorage == true) {
                // LocalStorage
                window.localStorage.setItem(storageName, storageData);

            } else {
                // SessionStorage
                window.sessionStorage.setItem(storageName, storageData);
            }
            return true;
        }
        else {
            return false;
        }

    };

    // Update HTML Document Title
    updateDocumentTitle = function (pageTitle, currentDocumentTitle) {

        let documentTitleSeparator = "|";
        let regExp = new RegExp('[\'' + documentTitleSeparator + ']', "g");

        currentDocumentTitle = !!!currentDocumentTitle ? document.title : currentDocumentTitle;

        let separatorCount = (currentDocumentTitle.match(regExp) || []).length;

        if (separatorCount > 1) {
            currentDocumentTitle = currentDocumentTitle.substring(currentDocumentTitle.indexOf(documentTitleSeparator + " ") + 1);
        }

        return document.title = pageTitle + " " + documentTitleSeparator + " " + currentDocumentTitle.trim();

    };

    // Initialise JS Class and functions
    return {


        init: function () {
            // DEBUG RELATED
            if (global.debug_mode) {
                console.log("Debug Mode: " + global.debug_mode);
            }

            // Update breakpoint/viewport
            global.breakpoint = bootstrapDetectBreakpoint();

            // Update breakpoint/viewport
            window.addEventListener('resize', function () {

                if (!!global.breakpoint) {
                    let currentBreakpointIndex = global.breakpoint;
                    global.breakpoint = bootstrapDetectBreakpoint();
                }
                else {
                    global.breakpoint = bootstrapDetectBreakpoint();
                }

                if (global.debug_mode) {
                    console.log(global.breakpoint);
                }
            });


            // Sticky header compnent - set offset  dynamically based on the header height
            window.addEventListener('resize', components.stickComponentHeader());

            // Components Used throughout the site
            components.bs_carousel();
            components.stickyHeader();
            components.stickComponentHeader();
            components.wow();
            components.lazyLoad();
            components.modal.inline();
            components.modal.iframe();
            //components.privacy_consent();
            components.smoothScroll();
            components.navBarToggle();
            components.forms.init(); // Standard Boostrap validation https://getbootstrap.com/docs/4.6/components/forms/#validation
            
            components.sticky_cta.init();

            // Page Specific functions
            pages();



        },
    };

}());

jQuery(function () {

    SparkDigital.init();




});

